module.exports = __webpack_public_path__ + "img/shopee-ITU-1.e732a7a3.png";